import { IWorkItem } from '@models/works';
import {
  AmbivalenceJPG,
  ArchJPG,
  BuffaloesJPG,
  ChaseJPG,
  Cityscape1JPG,
  Cityscape2JPG,
  Cityscape3JPG,
  CompetitionJPG,
  Essence1JPG,
  Essence2JPG,
  EvgNoName1JPG,
  EvgNoName2JPG,
  EvgNoName3JPG,
  FearOfLivingJPG,
  FeelJPG,
  FemlagomorphaCarnivoraJPG,
  FuneralOfACatJPG,
  IbisesAndTheWhaleJPG,
  InsomniaJPG,
  Soul1JPG,
  Soul2JPG,
  SpiderJPG,
  StuporJPG,
  UncertaintyJPG,
} from '@assets/cabinet';

export const cabinet_works_list: Array<IWorkItem> = [
  {
    id: 'evg-no-name',
    img: [EvgNoName1JPG, EvgNoName2JPG, EvgNoName3JPG],
    author: 'Евгений Иванов',
    year: '2024',
    price: 12000,
    info: 'смешанная техника',
    size: '40х55см',
    media: [
      {
        label: 'tg',
        value: '@nitrogenique',
        link: 'https://t.me/nitrogenique',
      },
    ],
  },
  {
    id: 'insomnia',
    img: [InsomniaJPG],
    author: 'Настя Соня Ярo',
    name: 'Инсомния',
    year: '2021',
    price: 25000,
    info: 'акрил, холст',
    size: '30х50см',
    media: [
      {
        label: 'inst',
        value: '@yaro.nastyasonya',
        link: 'https://www.instagram.com/yaro.nastyasonya',
      },
    ],
  },
  {
    id: 'chase',
    img: [ChaseJPG],
    author: 'Zazola_Fun',
    name: 'Погоня',
    year: '2024',
    priceInfo: 'договорная цена',
    info: 'интерьерная живопись с использованием искусственной шерсти и битумного лака',
    size: '40х50см',
    media: [
      {
        label: 'tg',
        value: '@Zazola_MARTINS_Fun',
        link: 'https://t.me/Zazola_MARTINS_Fun',
      },
    ],
  },
  {
    id: 'ambivalence',
    img: [AmbivalenceJPG],
    author: 'Zazola_Fun',
    name: 'Амбивалентность',
    year: '2024',
    priceInfo: 'договорная цена',
    info: 'интерьерная живопись с эффектом кракле и перламутром',
    size: '40х70см',
    media: [
      {
        label: 'tg',
        value: '@Zazola_MARTINS_Fun',
        link: 'https://t.me/Zazola_MARTINS_Fun',
      },
    ],
  },
  {
    id: 'soul',
    img: [Soul1JPG, Soul2JPG],
    author: 'Zazola_Fun',
    name: 'Душа',
    year: '2024',
    priceInfo: 'договорная цена',
    info: 'интерьерная живопись с использованием искусственной шерсти',
    size: '60х40см',
    media: [
      {
        label: 'tg',
        value: '@Zazola_MARTINS_Fun',
        link: 'https://t.me/Zazola_MARTINS_Fun',
      },
    ],
  },
  {
    id: 'competition',
    img: [CompetitionJPG],
    author: 'Ирина Кексель',
    name: 'Конкуренция',
    year: '2024',
    price: 10000,
    info: 'масло, ДВП',
    size: '40х40см',
    media: [
      {
        label: 'inst',
        value: '@kuklaiira',
        link: 'https://www.instagram.com/kuklaiira',
      },
    ],
  },
  {
    id: 'funeral-of-a-cat',
    img: [FuneralOfACatJPG],
    author: 'Адам Норин',
    name: 'Похороны кота',
    year: '2018',
    price: 20000,
    info: 'масло, картон',
    size: '40х60см',
    media: [
      {
        label: 'inst',
        value: '@adam.norin',
        link: 'https://www.instagram.com/adam.norin',
      },
    ],
  },
  {
    id: 'arch',
    img: [ArchJPG],
    author: 'Адам Норин',
    name: 'Арка',
    year: '2020',
    price: 60000,
    info: 'масло, картон',
    size: '80х100см',
    media: [
      {
        label: 'inst',
        value: '@adam.norin',
        link: 'https://www.instagram.com/adam.norin',
      },
    ],
  },
  {
    id: 'buffaloes',
    img: [BuffaloesJPG],
    author: 'Адам Норин',
    name: 'Буйволы',
    year: '2017',
    price: 100000,
    info: 'масло, холст',
    size: '60х80см',
    media: [
      {
        label: 'inst',
        value: '@adam.norin',
        link: 'https://www.instagram.com/adam.norin',
      },
    ],
  },
  {
    id: 'ibises-and-the-whale',
    img: [IbisesAndTheWhaleJPG],
    author: 'Адам Норин',
    name: 'Ибисы и кит',
    year: '2017',
    price: 80000,
    info: 'масло, холст',
    size: '55х83см',
    media: [
      {
        label: 'inst',
        value: '@adam.norin',
        link: 'https://www.instagram.com/adam.norin',
      },
    ],
  },
  {
    id: 'fear-of-living',
    img: [FearOfLivingJPG],
    author: 'Адам Норин',
    name: 'Страх жить',
    year: '2023',
    price: 130000,
    info: 'масло, холст',
    size: '75х75см',
    media: [
      {
        label: 'inst',
        value: '@adam.norin',
        link: 'https://www.instagram.com/adam.norin',
      },
    ],
  },
  {
    id: 'femlagomorpha-carnivora',
    img: [FemlagomorphaCarnivoraJPG],
    author: 'Адам Норин',
    name: 'Femlagomorpha Carnivora',
    year: '2019',
    price: 130000,
    info: 'масло, холст',
    size: '80x130см',
    media: [
      {
        label: 'inst',
        value: '@adam.norin',
        link: 'https://www.instagram.com/adam.norin',
      },
    ],
  },
  {
    id: 'cityscape',
    img: [Cityscape1JPG, Cityscape2JPG, Cityscape3JPG],
    author: 'Анна Осколкова ',
    name: 'Городской пейзаж',
    year: '2023',
    priceInfo: 'каждая',
    price: 500,
    info: 'фотография',
    size: 'A3',
    media: [
      {
        label: 'inst',
        value: '@greoski_ph',
        link: 'https://www.instagram.com/greoski_ph',
      },
    ],
  },
  {
    id: 'feel',
    img: [FeelJPG],
    author: 'irkytskkk',
    name: 'Это единственное, что я сейчас чувствую',
    year: '2023',
    price: 5000,
    info: 'уголь',
    size: '40х50см',
    media: [
      {
        label: 'inst',
        value: '@irkytskkk',
        link: 'https://www.instagram.com/irkytskkk',
      },
    ],
  },
  {
    id: 'spider',
    img: [SpiderJPG],
    author: 'Авдотья Белая',
    name: 'Паук',
    year: '2024',
    price: 15000,
    info: 'Импасто, акрил на оргалите, инкрустация осколками зеркала',
    size: '50х70см',
    media: [
      {
        label: 'inst',
        value: '@vivid_1nk',
        link: 'https://www.instagram.com/vivid_1nk',
      },
    ],
  },
  {
    id: 'uncertainty',
    img: [UncertaintyJPG],
    author: 'Евгений Севостьянов',
    name: 'Неопределенность',
    year: '2023',
    price: 30000,
    info: 'холст, акрил на подрамнике',
    size: '80х80см',
    media: [
      {
        label: 'inst',
        value: '@sevosphoto',
        link: 'https://www.instagram.com/sevosphoto',
      },
    ],
  },
  {
    id: 'essence',
    img: [Essence1JPG, Essence2JPG],
    author: 'Евгений Севостьянов',
    name: 'Эссенция',
    year: '2023',
    price: 50000,
    info: 'диптих  холст, акрил на подрамнике',
    size: '120х90см',
    media: [
      {
        label: 'inst',
        value: '@sevosphoto',
        link: 'https://www.instagram.com/sevosphoto',
      },
    ],
  },
  {
    id: 'stupor',
    img: [StuporJPG],
    author: 'A.gremlin',
    name: 'Ступор',
    year: '2024',
    price: 25000,
    info: 'масло, холст',
    size: '50×70см',
    media: [
      {
        label: 'inst',
        value: '@a_grmln',
        link: 'https://www.instagram.com/a_grmln',
      },
    ],
  },
];
